module.exports = {"340202012":"方村街道","340202401":"张家山公共服务中心","340202402":"赭麓公共服务中心","340202403":"滨江公共服务中心","340202404":"赭山公共服务中心","340202405":"弋矶山公共服务中心","340202406":"汀棠公共服务中心","340202407":"天门山公共服务中心","340202408":"大砻坊公共服务中心","340202409":"镜湖新城公共服务中心","340202410":"荆山公共服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340202.json
// module id = 964
// module chunks = 0